module.exports = __webpack_public_path__ + "static/media/YF69_0.9936aa93.jpg";